module.exports = __webpack_public_path__ + "img/shangtang.b0edc3ef.png";